module.exports = __webpack_public_path__ + "static/media/background.89304de7.jpg";